<template>
  <v-layout row justify-end class="management-add-button-container">
    <v-flex shrink>
      <missing-permissions-tooltip
        :missing-permissions-list="listMissingPermissions"
      >
        <v-btn
          color="accent"
          @click.stop="click"
          :disabled="disabled"
          class="ma-0 management-button"
        >
          <v-icon left>add_circle</v-icon>
          <span style="font-size: 12px; text-transform: none">
            {{ label }}
          </span>
        </v-btn>
      </missing-permissions-tooltip>
    </v-flex>
  </v-layout>
</template>

<script>
import MissingPermissionsTooltip from "@/components/_Atoms/MissingPermissionsTooltip";

export default {
  name: "ManagementAddButton",

  components: { MissingPermissionsTooltip },

  props: {
    /**
     * Label of the button
     */
    label: {
      type: String,
      required: true
    },

    /**
     * Indicates if the button is disabled or not
     */
    disabled: {
      type: Boolean,
      default: false
    },

    /**
     * List of missing permissions for the user being able add
     */
    listMissingPermissions: {
      type: Array,
      required: true
    }
  },

  methods: {
    /**
     * Emits an event when the button is clicked
     */
    click(e) {
      this.$emit("buttonClick", e);
    }
  }
};
</script>

<style scoped>
/**
 * Div style involving create button
 */
.management-add-button-container {
  height: 90px;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Management/ManagementAddButton.vue